
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../../utils";
// import { useAuthHeaders } from "../../components/Token";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import Swal from "sweetalert2";
// import "./propertyView.css";
// import { BsThreeDotsVertical } from "react-icons/bs";
// import { FcEmptyTrash, FcOk, FcReading } from "react-icons/fc";
// import { formatDistanceToNow, parseISO } from "date-fns";
// import { Dropdown } from "react-bootstrap";

// const ITEMS_PER_PAGE = 5;

// function PropertyView() {
//   const [properties, setProperties] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [expandedProperty, setExpandedProperty] = useState(null);
//   const headers = useAuthHeaders();
//   const [loading, setLoading] = useState(true);

//   const handleDelete = (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Are you sure you want to delete this Property?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         axios
//           .delete(`${API_BASE_URL}/property/deletproperty/${id}`, { headers })
//           .then(() => {
//             setProperties((prevData) =>
//               prevData.filter((item) => item._id !== id)
//             );
//           })
//           .catch((error) => {
//             console.error("Error deleting property:", error);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: error.response?.data?.error || "An error occurred",
//             });
//           });

//         Swal.fire({
//           title: "Deleted!",
//           text: "Your Property has been deleted.",
//           icon: "success",
//         });
//       }
//     });
//   };

//   const handleDeactivate = (id) => {
//     axios
//       .patch(`${API_BASE_URL}/property/deactivate/${id}`, {}, { headers })
//       .then(() => {
//         setProperties((prevData) =>
//           prevData.map((item) =>
//             item._id === id ? { ...item, status: "Inactive" } : item
//           )
//         );
//         Swal.fire({
//           title: "Deactivated!",
//           text: "The property has been deactivated.",
//           icon: "success",
//         });
//       })
//       .catch((error) => {
//         console.error("Error deactivating property:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response?.data?.error || "An error occurred",
//         });
//       });
//   };

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/property/getproperty`, { headers })
//       .then((response) => {
//         const fetchedProperties = response.data.data.property;
//         if (Array.isArray(fetchedProperties)) {
//           console.log(fetchedProperties,"fetchingdataformviewproprty")
//           setProperties(fetchedProperties);
//           setLoading(false);
//         } else {
//           setProperties([]);
//           setLoading(false);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching properties:", error);
//         setLoading(false);
//       });
//   }, [headers]);

//   const formatDateTraditional = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const formatDateRelative = (dateString) => {
//     const date = parseISO(dateString);
//     return formatDistanceToNow(date, { addSuffix: true });
//   };

//   const handleToggleDetails = (id) => {
//     setExpandedProperty(expandedProperty === id ? null : id);
//   };

//   // Pagination logic
//   const indexOfLastProperty = currentPage * ITEMS_PER_PAGE;
//   const indexOfFirstProperty = indexOfLastProperty - ITEMS_PER_PAGE;
//   const currentProperties = properties.slice(indexOfFirstProperty, indexOfLastProperty);
//   const totalPages = Math.ceil(properties.length / ITEMS_PER_PAGE);

//   return (
//     <div className="container mt-5">
//       <h5 className="mb-4">Property List</h5>
//       {loading ? (
//         <div className="text-center">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : currentProperties.length > 0 ? (
//         <>
//           <table className="table table-bordered table-striped">
//             <thead>
//               <tr className="text-center">
//                 <th>S.No</th>
//                 <th>Title</th>
//                 <th >Url</th>
//                 <th>Location & Pincode</th>
//                 <th>Property Image Count</th>
//                 <th>Created & Updated</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//   {currentProperties.map((property, index) => (
//     <React.Fragment key={property._id}>
//       <tr className="text-center">
//         <td data-label="S.No">{index + 1 + (currentPage - 1) * ITEMS_PER_PAGE}</td>
//         <td data-label="Title">{property.propertyTitle}</td>
//         <td data-label="Url">
//           <Link to={`/mygallery/${property._id}`}>
//             {property.slug}
//           </Link>
//         </td>
//         <td data-label="Location & Pincode">{property.location}</td>
//         <td data-label="Property Image Count" >
//           {property.propertyImages.length} Images
//         </td>
//         <td data-label="Created & Updated" className="fs-6">
//           <p style={{ fontSize: "12px" }}>
//             {formatDateTraditional(property.createdAt)}<br />
//             <em>({formatDateRelative(property.createdAt)})</em><br />
//             {formatDateTraditional(property.updatedAt)}<br />
//             <em>({formatDateRelative(property.updatedAt)})</em>
//           </p>
//         </td>
//         <td data-label="Action">
//           <Dropdown>
//             <Dropdown.Toggle className="btns border border-0">
//               <BsThreeDotsVertical />
//             </Dropdown.Toggle>
//             <Dropdown.Menu>
//               <Dropdown.Item>
//                 <button className="mx-1 border border-0 btnss">
//                   <Link
//                     to={`/mygallery/${property._id}`}
//                     className="text-decoration-none text-black"
//                   >
//                     <FcReading className="m-2 fs-5" /> View
//                   </Link>
//                 </button>
//               </Dropdown.Item>
//               <Dropdown.Item>
//                 <button
//                   className="mx-1 border border-0 btnss"
//                   onClick={() => handleDelete(property._id)}
//                 >
//                   <FcEmptyTrash className="m-2 fs-5" /> Delete
//                 </button>
//               </Dropdown.Item>
//               <Dropdown.Item>
//                 <button className="mx-1 border border-0 btnss">
//                   <Link
//                     to={`/EditNewProducts/${property._id}`}
//                     className="text-decoration-none text-black"
//                   >
//                     <FcOk className="m-2 fs-5" /> Edit
//                   </Link>
//                 </button>
//               </Dropdown.Item>
//             </Dropdown.Menu>
//           </Dropdown>
//         </td>
//       </tr>
//       {expandedProperty === property._id && (
//         <tr>
//           <td colSpan="7">
//             <div className="expanded-details">
//               <p>{property.propertyDescription}</p>
//               <p><strong>More Details:</strong> {property.additionalDetails}</p>
//             </div>
//           </td>
//         </tr>
//       )}
//     </React.Fragment>
//   ))}
// </tbody>

//           </table>
//           <div className="d-flex justify-content-center mt-4">
//             <nav>
//               <ul className="pagination">
//                 <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                   <button onClick={prevPage} className="page-link">Previous</button>
//                 </li>
//                 {[...Array(Math.ceil(data.length / propertiesPerPage)).keys()].map((number) => (
//                   <li key={number} className={`page-item ${currentPage === number + 1 ? 'active' : ''}`}>
//                     <button onClick={() => paginate(number + 1)} className="page-link">
//                       {number + 1}
//                     </button>
//                   </li>
//                 ))}
//                 <li className={`page-item ${currentPage === Math.ceil(data.length / propertiesPerPage) ? 'disabled' : ''}`}>
//                   <button onClick={nextPage} className="page-link">Next</button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </>
//       ) : (
//         <div className="text-center mt-5">
//           <p>No properties found...</p>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PropertyView;




import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../utils";
import { useAuthHeaders } from "../../components/Token";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import "./propertyView.css";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FcEmptyTrash, FcOk, FcReading } from "react-icons/fc";
import { formatDistanceToNow, parseISO } from "date-fns";
import { Dropdown } from "react-bootstrap";

const ITEMS_PER_PAGE = 5;

function PropertyView() {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedProperty, setExpandedProperty] = useState(null);
  const headers = useAuthHeaders();
  const [loading, setLoading] = useState(true);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Property?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_BASE_URL}/property/deletproperty/${id}`, { headers })
          .then(() => {
            setProperties((prevData) =>
              prevData.filter((item) => item._id !== id)
            );
          })
          .catch((error) => {
            console.error("Error deleting property:", error);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response?.data?.error || "An error occurred",
            });
          });

        Swal.fire({
          title: "Deleted!",
          text: "Your Property has been deleted.",
          icon: "success",
        });
      }
    });
  };

  const handleDeactivate = (id) => {
    axios
      .patch(`${API_BASE_URL}/property/deactivate/${id}`, {}, { headers })
      .then(() => {
        setProperties((prevData) =>
          prevData.map((item) =>
            item._id === id ? { ...item, status: "Inactive" } : item
          )
        );
        Swal.fire({
          title: "Deactivated!",
          text: "The property has been deactivated.",
          icon: "success",
        });
      })
      .catch((error) => {
        console.error("Error deactivating property:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.error || "An error occurred",
        });
      });
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/property/getproperty`, { headers })
      .then((response) => {
        const fetchedProperties = response.data.data.property;
        if (Array.isArray(fetchedProperties)) {
          console.log(fetchedProperties, "fetchingdataformviewproprty");
          setProperties(fetchedProperties);
          setLoading(false);
        } else {
          setProperties([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching properties:", error);
        setLoading(false);
      });
  }, [headers]);

  const formatDateTraditional = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatDateRelative = (dateString) => {
    const date = parseISO(dateString);
    return formatDistanceToNow(date, { addSuffix: true });
  };

  const handleToggleDetails = (id) => {
    setExpandedProperty(expandedProperty === id ? null : id);
  };

  const prevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const nextPage = () => {
    setCurrentPage((prev) =>
      Math.min(prev + 1, Math.ceil(properties.length / ITEMS_PER_PAGE))
    );
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Pagination logic
  const indexOfLastProperty = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstProperty = indexOfLastProperty - ITEMS_PER_PAGE;
  const currentProperties = properties.slice(
    indexOfFirstProperty,
    indexOfLastProperty
  );
  const totalPages = Math.ceil(properties.length / ITEMS_PER_PAGE);

  return (
    <div className="container mt-5">
      <h5 className="mb-4">Property List</h5>
      {loading ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : currentProperties.length > 0 ? (
        <>
          <table className="table table-bordered table-striped">
            <thead>
              <tr className="text-center">
                <th>S.No</th>
                <th>Title</th>
                <th>Url</th>
                <th>Location & Pincode</th>
                <th>Property Image Count</th>
                <th>Created & Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentProperties.map((property, index) => (
                <React.Fragment key={property._id}>
                  <tr className="text-center">
                    <td data-label="S.No">
                      {index + 1 + (currentPage - 1) * ITEMS_PER_PAGE}
                    </td>
                    <td data-label="Title">{property.propertyTitle}</td>
                    <td data-label="Url">
                      <Link to={`/mygallery/${property._id}`}>
                        {property.slug}
                      </Link>
                    </td>
                    <td data-label="Location & Pincode">
                      {property.location}
                    </td>
                    <td data-label="Property Image Count">
                      {property.propertyImages.length} Images
                    </td>
                    <td data-label="Created & Updated" className="fs-6">
                      <p style={{ fontSize: "12px" }}>
                        {formatDateTraditional(property.createdAt)}
                        <br />
                        <em>({formatDateRelative(property.createdAt)})</em>
                        <br />
                        {formatDateTraditional(property.updatedAt)}
                        <br />
                        <em>({formatDateRelative(property.updatedAt)})</em>
                      </p>
                    </td>
                    <td data-label="Action">
                      <Dropdown>
                        <Dropdown.Toggle className="btns border border-0">
                          <BsThreeDotsVertical />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item>
                            <button className="mx-1 border border-0 btnss">
                              <Link
                                to={`/mygallery/${property._id}`}
                                className="text-decoration-none text-black"
                              >
                                <FcReading className="m-2 fs-5" /> View
                              </Link>
                            </button>
                          </Dropdown.Item>
                          <Dropdown.Item>
                            <button
                              className="mx-1 border border-0 btnss"
                              onClick={() => handleDelete(property._id)}
                            >
                              <FcEmptyTrash className="m-2 fs-5" /> Delete
                            </button>
                          </Dropdown.Item>
                          <Dropdown.Item>
                            <button className="mx-1 border border-0 btnss">
                              <Link
                                to={`/EditNewProducts/${property._id}`}
                                className="text-decoration-none text-black"
                              >
                                <FcOk className="m-2 fs-5" /> Edit
                              </Link>
                            </button>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                  {expandedProperty === property._id && (
                    <tr>
                      <td colSpan="7">
                        <div className="expanded-details">
                          <p>{property.propertyDescription}</p>
                          <p>
                            <strong>More Details:</strong>{" "}
                            {property.additionalDetails}
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button onClick={prevPage} className="page-link">
                    Previous
                  </button>
                </li>
                {[...Array(totalPages).keys()].map((number) => (
                  <li
                    key={number}
                    className={`page-item ${
                      currentPage === number + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      onClick={() => paginate(number + 1)}
                      className="page-link"
                    >
                      {number + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button onClick={nextPage} className="page-link">
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </>
      ) : (
        <div className="text-center mt-5">
          <p>No properties found...</p>
        </div>
      )}
    </div>
  );
}

export default PropertyView;
